import { Box, Card, CardContent, Typography } from "@material-ui/core";
import * as React from "react";
import { useDataProvider } from "react-admin";
import { useAuth } from "@airborne/react-admin";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@material-ui/lab";
import { useState } from "react";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { Add, LocalOffer, ThumbDown, ThumbUp } from "@material-ui/icons";
import { RequestStatus } from "../../../../src/Enums/RequestStatus";
import { formatDate } from "../../../Helper/MomentHelper";

type RequestHistoryTimeLineProps = {
  request: any;
  source?: string;
  isShowFooter?: boolean;
  footerMessages?: string[];
  [key: string]: any;
};

const RequestHistoryTimeLine = ({
  request,
  source = "requesthistorys",
  isShowFooter = false,
  footerMessages = [],
  ...rest
}: RequestHistoryTimeLineProps) => {
  const provider = useDataProvider();
  const { user } = useAuth();
  const [requestHistory, setRequestHistory] = useState<any>([] as any);

  React.useEffect(() => {
    if (request !== null && request !== undefined) {
      getData();
    }
  }, [request?.id]);

  const getData = async () => {
    if (request !== null && request !== undefined) {
      const { data } = await provider.getList(source, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "createdDate", order: "DESC" },
        filter: { requestId__eq: request.id },
      });

      if (data !== null && data !== undefined && data.length > 0) {
        setRequestHistory(data);
        getSecondData();
      }
    }
  };
  const getSecondData = async () => {
    if (rest?.secondRequest !== null && rest?.secondRequest !== undefined) {
      const { data } = await provider.getList(rest?.secondSource, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "createdDate", order: "DESC" },
        filter: { requestId__eq: rest?.secondRequest.id },
      });

      if (data !== null && data !== undefined && data.length > 0) {
        setRequestHistory(tempData => {
          var newData = tempData
            ?.concat?.(data)
            ?.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
          return newData;
        });
      }
    }
  };

  const timeLineIcon = (historyStatus: RequestStatus) => {
    let icon, color;
    switch (historyStatus) {
      case RequestStatus.Created:
        icon = <Add />;
        color = "primary";
        break;
      case RequestStatus.NotPool:
        icon = <ThumbUp />;
        color = "secondary";
        break;
      case RequestStatus.DocumentZeroValue:
        icon = <ThumbDown />;
        color = "secondary";
        break;
      case RequestStatus.NoCapability:
        icon = <LocalOffer />;
        color = "primary";
        break;
      case RequestStatus.ReturnManuelCoverageControl:
        icon = <ThumbUp />;
        color = "secondary";
        break;
      case RequestStatus.Pool:
        icon = <ThumbDown />;
        color = "secondary";
        break;
      case RequestStatus.SendShippingDetails:
        icon = <LocalOffer />;
        color = "primary";
        break;
      case RequestStatus.PlaneLanded:
        icon = <ThumbUp />;
        color = "secondary";
        break;
      case RequestStatus.NotPlmsStatus:
        icon = <ThumbDown />;
        color = "secondary";
        break;
      case RequestStatus.PoolUserAccept:
        break;
      case RequestStatus.PoolUserReject:
        break;
    }

    return <TimelineDot color={color}>{icon}</TimelineDot>;
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box display={{ sm: "block", md: "flex" }}>
            <Box flex={2}>
              <div>
                <span style={{ color: "#cc0000", fontWeight: "bold" }}>Customer Po: </span>
                <span style={{ fontWeight: "bold" }}>{request?.customerPo ?? "-"}</span>
              </div>
            </Box>
            <Box flex={2}>
              <div>
                <span style={{ color: "#cc0000", fontWeight: "bold" }}>Ref No: </span>
                <span style={{ fontWeight: "bold" }}>{request?.refNo ?? "-"}</span>
              </div>
            </Box>
          </Box>

          {!user?.isCustomer && (
            <>
              <Box display={{ sm: "block", md: "flex" }} mt={2}>
                <Box flex={2}>
                  <div>
                    <span style={{ color: "#cc0000", fontWeight: "bold" }}>RDD: </span>
                    <span style={{ fontWeight: "bold" }}>{formatDate(request?.requestedDeliveryDate)}</span>
                  </div>
                </Box>
                <Box flex={2}>
                  <div>
                    <span style={{ color: "#cc0000", fontWeight: "bold" }}>SVC FDC: </span>
                    <span style={{ fontWeight: "bold" }}>
                      {formatDate(request?.pbhRequestServiceable?.forwardDateToCarrier)}
                    </span>
                  </div>
                </Box>
              </Box>
              <Box display={{ sm: "block", md: "flex" }} mt={2}>
                <Box flex={4}>
                  <div>
                    <span style={{ color: "#cc0000", fontWeight: "bold" }}>US FDC: </span>
                    <span style={{ fontWeight: "bold" }}>
                      {formatDate(request?.pbhRequestUnserviceable?.forwardDateToCarrier)}
                    </span>
                  </div>
                </Box>
              </Box>
            </>
          )}
        </CardContent>
      </Card>

      <Timeline align="alternate">
        {requestHistory.map(history => (
          <TimelineItem key={history.id}>
            <TimelineOppositeContent>
              <Typography variant="h6" color="primary">
                <CreatedByField record={history} link={false} />
              </Typography>
              <Typography>{formatDate(history.createdDate)}</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector />
              {timeLineIcon(history.historyId)}
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="h6" component="span">
                {history.statusCode}
              </Typography>
              <Typography variant="h6" color="primary">
                {history.displayName}
              </Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>

      {isShowFooter && (
        <Card>
          <CardContent>
            {footerMessages?.map((message, index) => {
              return (
                <Box display={{ sm: "block", md: "flex" }} key={index}>
                  <Box flex={2}>
                    <div>
                      <span style={{ color: "#cc0000", fontWeight: "bold", justifyContent: "center", display: "flex" }}>
                        {" "}
                        {message}
                      </span>
                    </div>
                  </Box>
                </Box>
              );
            })}
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default RequestHistoryTimeLine;
